function checkAddress() {
  var country = $("#billing_country").val();
  if (country !== "GB") {
    $(".gift-aid-panel").hide();
  } else {
    $(".gift-aid-panel").show();
  }
}

// Check address on page load
checkAddress();

// Check address on change of country field
$("#billing_country").change(function () {
  checkAddress();
});

// Check address on change of any address field
$(
  "#billing_address_1, #billing_address_2, #billing_city, #billing_postcode"
).change(function () {
  checkAddress();
});
